import {useCallback, useEffect, useRef} from 'react';

export function useTimeoutRef() {
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout>>();

  const resetTimeout = useCallback(() => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
  }, []);

  useEffect(() => {
    return () => {
      resetTimeout();
    };
  }, [resetTimeout]);

  return timeoutIdRef;
}
